import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'antd';
import Group from '@views/Group';
import { groups as groupLetters } from '@models/Match';

export const Groups = ({ groups }) => (
  <Row gutter={16}>
    {groups.map((letter) => (
      <Col
        key={letter}
        xs={24}
        md={12}
        lg={8}
        xl={6}
        style={{ marginBottom: '15px' }}
      >
        <Group group={letter} />
      </Col>
    ))}
  </Row>
);

Groups.displayName = 'Groups';
Groups.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.string),
};
Groups.defaultProps = {
  groups: groupLetters,
};

export default Groups;
